export const getQrCodeLink = () => {
  const url: URL = new URL(window.location.href);

  if (!url.href.includes('viewOnly=true')) {
    url.searchParams.append('viewOnly', 'true');
  }

  return url.href;
};
